import ConversationApi from '../../api/inbox/conversation';

// Contagens usadas só pelos badges numéricos da sidebar (total no grupo
// "Dashboard" + total por quadro/atributo). Não guardamos as conversas
// em si aqui — isso já é responsabilidade da própria página do Kanban.
export const state = {
  totalCount: 0,
  countsByAttributeKey: {},
};

export const getters = {
  getTotalCount: _state => _state.totalCount,
  getCountForAttribute: _state => attributeKey =>
    _state.countsByAttributeKey[attributeKey] || 0,
};

export const actions = {
  fetchCounts: async ({ commit }, attributeKeys = []) => {
    if (!attributeKeys.length) {
      commit('SET_KANBAN_BOARD_COUNTS', {});
      return;
    }

    const entries = await Promise.all(
      attributeKeys.map(async attributeKey => {
        try {
          // "is_present" conta toda conversa que já tem QUALQUER valor
          // definido para este atributo — ou seja, o total de cards do
          // quadro inteiro, somando todas as colunas dele.
          const response = await ConversationApi.filter({
            queryData: {
              payload: [
                {
                  attribute_key: attributeKey,
                  filter_operator: 'is_present',
                  values: [],
                  query_operator: null,
                },
              ],
            },
            page: 1,
          });
          return [attributeKey, response.data?.meta?.all_count || 0];
        } catch (error) {
          return [attributeKey, 0];
        }
      })
    );

    commit('SET_KANBAN_BOARD_COUNTS', Object.fromEntries(entries));
  },
};

export const mutations = {
  SET_KANBAN_BOARD_COUNTS(_state, countsByAttributeKey) {
    _state.countsByAttributeKey = countsByAttributeKey;
    _state.totalCount = Object.values(countsByAttributeKey).reduce(
      (sum, count) => sum + count,
      0
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
